import { Company } from '@shared-ikp/model/company.model';
import { FilterOption } from '@shared-ikp/model/filter-options.model';

export function concatCompanyNameAndGpNr(company: Company): string {
  return `${truncateLongName(company.name)}, ${company.gpNr}`;
}

export function findCompanyByGpNr(companies: Company[], gpNr: string | null | undefined): Company | null {
  if (!gpNr) {
    return null;
  }

  return companies.find(company => company.gpNr === gpNr) ?? null;
}

export function toCompanyOption(company: Company | null): FilterOption | null {
  if (!company) {
    return null;
  }

  return { text: concatCompanyNameAndGpNr(company), value: company.gpNr };
}

function truncateLongName(name: string, maxLength = 30): string {
  if (name.length <= maxLength) {
    return name;
  }
  return name.slice(0, maxLength) + '...';
}
